import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getUrl(path: string, params: Record<string, string> = {}) {
  const url = new URL(path, process.env.NEXT_PUBLIC_API_URL)
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value)
  })
  return url.toString()
}

function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16),
    ]
    : [0, 0, 0];
}

function interpolateColor(c1: number[], c2: number[], t: number) {
  return [
    Math.min(255, Math.max(0, Math.round(c1[0] + (c2[0] - c1[0]) * t))),
    Math.min(255, Math.max(0, Math.round(c1[1] + (c2[1] - c1[1]) * t))),
    Math.min(255, Math.max(0, Math.round(c1[2] + (c2[2] - c1[2]) * t))),
  ];
}

function componentToHex(c: number) {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function rgbToHex(r: number, g: number, b: number) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

export function getTailwindGradientColor(score: number) {
  const green = hexToRgb('#4ade80');  // green-400
  const yellow = hexToRgb('#fb923c'); // yellow-400
  const red = hexToRgb('#ef4444');    // red-500
  const via = 30; // 30% of the gradient

  if (score <= via) {
    const t = score / via;
    const [r, g, b] = interpolateColor(green, yellow, t);
    return rgbToHex(r, g, b);
  } else {
    const t = (score - via) / (100 - via);
    const [r, g, b] = interpolateColor(yellow, red, t);
    return rgbToHex(r, g, b);
  }
}

export async function copyToClipboard(text: string, inputRef: any): Promise<boolean> {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const node = inputRef?.current
    if (!node) {
      return false;
    }
    // Fallback for older browsers
    node.focus();
    node.select();

    return document.execCommand("copy");
  } catch (err) {
    console.error("Failed to copy: ", err);
    return false;
  }
}
